import { useAtom, useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { sourceTreeAtom } from './atoms'
import { useTreeGetter } from 'shared/hooks/trees/hooks'
import { Box, Button } from '@mui/material'
import { TreeIdInput } from '../navigationHelpers/TreeNodeRouter'
import React, { useEffect, useState } from 'react'
import { InfoDisplay } from '../../utility/Containers'

export function SourceTreeInput() {
  return (
    <Box padding="10px" border={'solid 1px'} borderRadius="5px">
      <SourceInputComponent />
    </Box>
  )
}

function SourceInputComponent() {
  const [treeIds, setTreeIds] = useState<{
    treeId: string | undefined
    versionId: string | undefined
  }>()
  const [sourceTree, treeSetter] = useAtom(sourceTreeAtom)
  const treeGetter = useTreeGetter()

  useEffect(() => {
    const treeId = treeIds?.treeId
    const versionId = treeIds?.versionId
    if (!treeId || !versionId) return
    const { tree } = treeGetter({ treeId, versionId })
    treeSetter(tree)
  }, [treeGetter, treeSetter, treeIds?.treeId, treeIds?.versionId])

  function removeSourceTree() {
    setTreeIds(undefined)
    treeSetter(undefined)
  }

  useEffect(() => {
    setTreeIds(undefined)
  }, [sourceTree])

  if (sourceTree || treeIds) {
    return (
      <Box>
        <InfoNode />
        <Button onClick={() => removeSourceTree()}>Remove Source</Button>
      </Box>
    )
  }

  return (
    <Box>
      <InfoNode />
      <TreeIdInput
        onChange={({ treeId, version }) => {
          setTreeIds({ treeId, versionId: version })
        }}
      />
    </Box>
  )
}

function InfoNode() {
  const tree = useAtomValue(sourceTreeAtom)
  return (
    <InfoDisplay>
      <Box>{`Source Tree: ${tree?.title ?? ''}`}</Box>
      <Box>
        This is the tree that will be used to copy nodes from, into the
        destination tree.
      </Box>
    </InfoDisplay>
  )
}
